import { ErrorLog } from "@/src/models/error-log";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getErrorLogsByTaskId(taskId: string): Promise<ErrorLog[]> {
  return fetchJSON<ErrorLog[]>(`/api/tasks/${taskId}/error-log`);
}
